import { decodeNumber } from "./decodeNumber";
import { NULL_VALUE_BY_WIDTH, WIDTH } from "./encodeNumberArray";
import { NUMBER_ARRAY_MARKER_BY_WIDTH } from "./markers";

const GETTER_BY_WIDTH = {
  1: "getUint8",
  2: "getUint16",
  4: "getUint32",
} as const;

// Reverse lookup: marker byte → width. Avoids Object.entries.find on every call.
const WIDTH_BY_ARRAY_MARKER: Record<number, WIDTH> = {
  [NUMBER_ARRAY_MARKER_BY_WIDTH[1]]: 1,
  [NUMBER_ARRAY_MARKER_BY_WIDTH[2]]: 2,
  [NUMBER_ARRAY_MARKER_BY_WIDTH[4]]: 4,
};

export function decodeNumberArray(
  data: Uint8Array,
  offset = 0,
): [(number | null)[], number] {
  const marker = data[offset];
  const width = WIDTH_BY_ARRAY_MARKER[marker] as WIDTH;
  // Pass offset directly instead of slicing — slice allocates a copy for every call.
  const [length, lengthBytes] = decodeNumber(data, offset + 1);
  const contentsStart = offset + 1 + lengthBytes;
  const contentsEnd = contentsStart + length * width;
  const contentsView = new DataView(
    data.buffer,
    data.byteOffset + contentsStart,
    length * width,
  );
  const getter = GETTER_BY_WIDTH[width];
  const nullValue = NULL_VALUE_BY_WIDTH[width];

  const array: (number | null)[] = [];
  for (let i = 0; i < length; i++) {
    const value = contentsView[getter](i * width);
    array.push(value === nullValue ? null : value);
  }

  const bytesConsumed = contentsEnd - offset;
  return [array, bytesConsumed];
}
